import { put, call } from "redux-saga/effects";

import { BFFAgent } from '../../../../common/BFFAgent';
import {
    GESTION_OPERATIVA_ADD_BILLS_FAILURE,
    GESTION_OPERATIVA_ADD_BILLS_SUCCESS
} from '../constants';


export function* addBillsSaga(body) {
    try {

        const bill = yield call(BFFAgent.Sales.addBills, body.data)

        if(bill){
            yield put({
                     type: GESTION_OPERATIVA_ADD_BILLS_SUCCESS,
                     data: bill
                   })
        }        

    } catch (err) {
        yield put({
            type: GESTION_OPERATIVA_ADD_BILLS_FAILURE,
            data: { error: err },
        })
    }

}



